<template>
    <eod-dialog :value="value" @input="val => $emit('input', val)" width="800" icon="mdi-waveform" iconColor="primary" :title="label" :inset="false" okText="Selecteren" @okAction="$emit('click', selected)">
            <slot name="search">
                <div class="px-4 py-4">
                <v-text-field type="search" dense solo label="Zoeken..." hide-details rounded v-model="search" @keyup="filterItems"></v-text-field>
            </div>
            </slot>
            <v-list dense>
            <v-virtual-scroll
        :items="filteredItems"
        height="800"
        max-height="80vh"
        item-height="50"
      >
        <template v-slot:default="{ item }">
        <v-list-item :disabled="disabled.includes(item.id)" @click="multiple?(selected.map(item => item.id).includes(item.id)?selected.splice(selected.map(item => item.id).indexOf(item.id), 1):selected.push(item)):(selected = [item])" :key="item.id">
            <v-list-item-action>
                <v-icon v-if="selected.map(item => item.id).includes(item.id)" color="primary">mdi-checkbox-marked</v-icon>
                <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        </template>
    </v-virtual-scroll>
    </v-list>
</eod-dialog>
</template>
<script>
export default {
    name: 'eod-object-selector',
    props:{
        label:{
            type: String,
            required:true
        },
        value: {
            type: Boolean,
        },
        endpoint: {
            type: String,
            required: true
        },
        fields: {
            type: Array,
            default: () => (['id','name'])
        },
        disabled: {
            type: Array,
            default: () => ([])
        },
        variables: {
            type: Object,
            default: () => ({})
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },
    data: () => {
        return {
            loading: false,
            items: [],
            search: null,
            filteredItems:[],
            selected: []
        }
    },
    mounted(){
        this.reload();
    },
    methods:{
        filterItems(){
            const self = this;
            if(this.search && this.search != ''){
                this.filteredItems = this.items.filter(function (el) {
                    return el.name.toLowerCase().includes(self.search.toLowerCase());
                });
            }else{
                this.filteredItems = this.items;
            } 
        },
        reload(){
            this.loading = true;
            this.$eod.get(this.endpoint, this.fields, this.variables)
                .then(response => {
                    if(response.data.data && response.data.data[this.endpoint]){
                        this.items = response.data.data[this.endpoint].edges;
                        this.filterItems();
                    }
                }).finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>